import axios from 'axios'
import { REACT_APP_PERITADOR_API } from '../../../config'

export async function saveTakingCarManagment(takingCarManagmentData) {
  const response = await axios.put(
    `${REACT_APP_PERITADOR_API}/takingCarManagment/`,
    {...takingCarManagmentData}
  )
  return response.data
}